export enum PlatformEnum {
  nativeOnly = 'native-only',
  auto = 'auto'
}
